import React, { useEffect, useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import ActivePositions from '../../components/ActivePositions/ActivePositions';
import FundsAndMargins from '../../components/FundsAndMargins/FundsAndMargins';
import TradingHubPage from '../tradingHub/TradingHubPage';
import OptionChainPage from '../optionChain/OptionChainPage';
import { useShellNav } from '../shell/ShellNavContext';
import { shellTokens } from '../shell/theme/shellTheme';

const TRADE_TABS = [
    { value: 'positions', label: 'Positions' },
    { value: 'funds', label: 'Funds' },
    { value: 'orders', label: 'Orders' },
    { value: 'optionchain', label: 'Option chain' },
];

const DEFAULT_TAB = TRADE_TABS[0].value;
const VALID_TABS = new Set(TRADE_TABS.map((tab) => tab.value));

const subTabSx = (active) => ({
    border: `1px solid ${active ? 'rgba(37, 99, 235, 0.25)' : shellTokens.border}`,
    bgcolor: active ? 'rgba(37, 99, 235, 0.1)' : shellTokens.surface,
    borderRadius: '8px',
    px: 1.75,
    py: 0.85,
    fontSize: '0.78rem',
    fontWeight: 700,
    color: active ? shellTokens.primary : shellTokens.muted,
    textTransform: 'none',
});

const TradePage = () => {
    const { subTab, setSubTab } = useShellNav();
    const [activeTab, setActiveTab] = useState(DEFAULT_TAB);

    useEffect(() => {
        if (subTab && VALID_TABS.has(subTab)) {
            setActiveTab(subTab);
        }
    }, [subTab]);

    const handleTabClick = (value) => {
        setActiveTab(value);
        setSubTab(value);
    };

    return (
        <Box>
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mb: 1.75 }}>
                {TRADE_TABS.map((tab) => (
                    <Button
                        key={tab.value}
                        sx={subTabSx(activeTab === tab.value)}
                        onClick={() => handleTabClick(tab.value)}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Stack>

            {activeTab === 'positions' ? <ActivePositions /> : null}
            {activeTab === 'funds' ? <FundsAndMargins /> : null}
            {activeTab === 'orders' ? <TradingHubPage /> : null}
            {activeTab === 'optionchain' ? <OptionChainPage /> : null}
        </Box>
    );
};

export default TradePage;
